import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
// یقینی بنائیں کہ آپ کی کسٹم CSS فائل یہاں امپورٹ ہے
import '../../UI/Common.css'; 

const SINGLE_PLAN = {
  id: 'carelinq_pro',
  name: 'Care Linq All-In-One Suite',
  badge: 'مکمل خودکار لائب ریٹنگ سسٹم',
  price: 3000,
  currency: 'PKR',
  billingPeriod: 'ماہانہ',
  description: 'جدید لیبارٹریز اور کلینکس کے لیے ایک ہی نظام میں تمام تر انتظام۔',
  features: [
    'لامحدود مریضوں کا اندراج اور ٹیسٹ بکنگ (Unlimited Patients)',
    'خودکار برانڈڈ PDF رپورٹ اور ڈاکٹر کی ڈیجیٹل دستخط',
    'بلنگ، رسیدیں اور واجبات (Dues) کا مکمل حساب کتاب',
    'واٹس ایپ / ای میل رپورٹس کی فوری ارسال (WhatsApp Integration)',
    'ملٹی یوزر رسائی (ایڈمن، لیب ٹیکنیشن اور ریسپشنسٹ)',
    'روزانہ آمدن، اخراجات اور مالیاتی تجزئیے کی رپورٹس'
  ]
};

const WHATSAPP_NUMBER = '923089394272';

const SubscriptionPlans = ({ labName = '', userEmail = '' }) => {
  const [labDetail, setLabDetail] = useState(labName);
  const [contactEmail, setContactEmail] = useState(userEmail);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);

  const handleWhatsAppRedirect = (e) => {
    e.preventDefault();

    const message = 
      `*Care Linq Subscription Request*\n\n` +
      `*Plan:* ${SINGLE_PLAN.name}\n` +
      `*Price:* ${SINGLE_PLAN.currency} ${SINGLE_PLAN.price.toLocaleString()}/${SINGLE_PLAN.billingPeriod}\n` +
      `*Lab/Facility Name:* ${labDetail || 'Not Provided'}\n` +
      `*Contact Email:* ${contactEmail || 'Not Provided'}\n\n` +
      `السلام علیکم! میں Care Linq سبسکرپشن حاصل کرنا چاہتا/چاہتی ہوں۔ براہ کرم سیٹ اپ اور ادائیگی کے لیے رہنمائی فرمائیں۔`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;

    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="common-background-color common-FontFamily Common-min-height py-4" dir="rtl">
      <div className="container" style={{ maxWidth: '1000px' }}>
        
        {/* Header Section */}
        <div className="common-text-center mb-4">
          <span className="badge bg-primary px-3 py-2 common-FontSize-small mb-2 common-br-3px">
            Care Linq Diagnostic & EMR Software
          </span>
          <h2 className="commont-Font-Bold common-color mb-2">آپ کی لیبارٹری کے تمام مسائل کا ایک حل</h2>
          <p className="text-muted common-FontSize-small">
            ہماری جدید ترین کلاؤڈ سروسز کے ساتھ اپنی لیب کی کارکردگی اور آمدن کو بڑھائیں۔
          </p>
        </div>

        {/* Core Solutions & Features Section */}
        <div className="row g-3 mb-4">
          
          <div className="col-md-4">
            <div className="common-bg-white common-box-shadow common-box-border p-3 common-text-center h-100">
              <div className="common-color mb-2 display-6">📋</div>
              <h6 className="common-FontWeight common-color mb-1">فوری اور آسان بلنگ</h6>
              <p className="text-muted common-Font-10 mb-0">
                مریض کا اندراج چند سیکنڈز میں کریں، خودکار رسیدیں جاری کریں اور بقایا جات کا حساب رکھیں۔
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="common-bg-white common-box-shadow common-box-border p-3 common-text-center h-100">
              <div className="text-success mb-2 display-6">📱</div>
              <h6 className="common-FontWeight common-color mb-1">واٹس ایپ رپورٹنگ</h6>
              <p className="text-muted common-Font-10 mb-0">
                ٹیسٹ کا نائج مکمل ہوتے ہی مریض کو ان کے واٹس ایپ پر براہِ راست PDF رپورٹ خودکار طریقے سے بھیجیں۔
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="common-bg-white common-box-shadow common-box-border p-3 common-text-center h-100">
              <div className="text-warning mb-2 display-6">📊</div>
              <h6 className="common-FontWeight common-color mb-1">مالیاتی حساب کتاب</h6>
              <p className="text-muted common-Font-10 mb-0">
                روزانہ کی آمدن، ٹیسٹ وائز مالیاتی تجزئیے اور کلینک کی مجموعی رپورٹ فوری حاصل کریں۔
              </p>
            </div>
          </div>

        </div>

        {/* Detailed Solutions Checklist */}
        <div className="common-bg-white common-box-shadow common-box-border p-4 mb-4">
          <h6 className="commont-Font-Bold common-color mb-3 border-bottom pb-2">
            نظام میں شامل بنیادی سہولیات (Software Features):
          </h6>
          <div className="row g-2">
            {SINGLE_PLAN.features.map((feature, idx) => (
              <div key={idx} className="col-md-6 d-flex align-items-center gap-2">
                <span className="badge bg-success rounded-circle p-1 common-Font-10">✓</span>
                <span className="common-Labels text-dark mb-0">{feature}</span>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Subscription Action Section */}
        <div className="common-bg-white common-box-shadow common-box-border p-4 common-text-center">
          <h5 className="commont-Font-Bold common-color mb-2">کیا آپ اپنی لیب کو جدید بنانا چاہتے ہیں؟</h5>
          <p className="common-FontSize-small text-muted mb-3">
            صرف PKR 3,000 ماہانہ میں مکمل سسٹم حاصل کریں اور بغیر کسی خفیہ اخراجات کے کام شروع کریں۔
          </p>
          
          <div>
            <button 
              className="btn btn-primary common-button px-4 py-2 common-FontSize-small common-cursor"
              onClick={() => setShowSubscriptionModal(true)}
            >
              سبسکرپشن پلان اور قیمت دیکھیں (Subscribe Now)
            </button>
          </div>
        </div>

        {/* Subscription Modal Section */}
        {showSubscriptionModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content common-modal common-box-shadow border-0">
                
                {/* Modal Header */}
                <div className="modal-header common-bg-white border-bottom py-2">
                  <h6 className="commont-Font-Bold common-color mb-0">Care Linq سبسکرپشن آرڈر کریں</h6>
                  <button 
                    type="button" 
                    className="common-cross-button common-cursor ms-0 me-auto fw-bold" 
                    onClick={() => setShowSubscriptionModal(false)}
                  >
                    ✕
                  </button>
                </div>

                {/* Modal Body */}
                <div className="modal-body p-3 common-FontFamily">
                  <div className="row g-3">
                    
                    {/* Left Column: Plan Details */}
                    <div className="col-md-6 border-start common-background-color p-3 common-br-3px">
                      <span className="badge bg-success mb-2 common-Font-10">{SINGLE_PLAN.badge}</span>
                      <h5 className="commont-Font-Bold text-dark mb-1">{SINGLE_PLAN.name}</h5>
                      <p className="text-muted common-Font-10 mb-2">{SINGLE_PLAN.description}</p>
                      
                      <div className="d-flex align-items-baseline gap-2 mb-3 common-bg-white p-2 common-box-border">
                        <span className="fs-4 commont-Font-Bold common-color">
                          {SINGLE_PLAN.currency} {SINGLE_PLAN.price.toLocaleString()}
                        </span>
                        <span className="text-muted common-Font-10">/ {SINGLE_PLAN.billingPeriod}</span>
                      </div>

                      <h6 className="common-Labels text-dark mb-2">اہم ترین سہولیات:</h6>
                      <ul className="list-unstyled common-Font-10 mb-0">
                        {SINGLE_PLAN.features.map((item, index) => (
                          <li key={index} className="mb-1 text-secondary">
                            • {item}
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Right Column: Form Inputs */}
                    <div className="col-md-6">
                      <h6 className="common-Labels text-dark mb-3">لیبارٹری کی تفصیلات فراہم کریں:</h6>
                      
                      <form onSubmit={handleWhatsAppRedirect}>
                        <div className="mb-3 common-text-start">
                          <label className="common-Labels mb-1">
                            لیبارٹری / کلینک کا نام <span className="common-Asterisk">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control common-Input p-2"
                            placeholder="مثال: الشفاء ڈائگنوسٹک لیب"
                            value={labDetail}
                            onChange={(e) => setLabDetail(e.target.value)}
                            required
                          />
                        </div>

                        <div className="mb-3 common-text-start">
                          <label className="common-Labels mb-1">
                            رابطہ ای میل <span className="common-Asterisk">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control common-Input p-2"
                            placeholder="name@labdomain.com"
                            value={contactEmail}
                            onChange={(e) => setContactEmail(e.target.value)}
                            required
                          />
                        </div>

                        <button 
                          type="submit" 
                          className="btn btn-success w-100 py-2 common-FontSize-small commont-Font-Bold common-cursor d-flex align-items-center justify-content-center gap-2 common-br-3px"
                          style={{ backgroundColor: '#25D366', borderColor: '#25D366' }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.64 1.93 6.56 6.56 0 0 1 1.928 4.64c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.099-.834-.308-1.587-.98-.588-.524-.985-1.172-1.1-1.37-.116-.197-.013-.304.085-.402.088-.088.197-.232.296-.348.1-.116.133-.197.197-.33.065-.133.033-.248-.017-.348-.05-.099-.445-1.072-.61-1.47-.16-.388-.323-.335-.445-.341l-.38-.007c-.131 0-.348.049-.529.248-.182.197-.698.683-.698 1.666 0 .983.715 1.934.816 2.067.101.133 1.408 2.15 3.411 3.016.476.206.848.328 1.138.421.479.153.914.131 1.258.08.384-.058 1.17-.478 1.334-.94.165-.461.165-.856.116-.94-.049-.083-.182-.148-.38-.247z"/>
                          </svg>
                          واٹس ایپ کے ذریعے رابطہ کریں (PKR 3,000)
                        </button>
                      </form>

                      <p className="text-muted common-Font-10 common-text-center mt-3 mb-0">
                        فوری سیٹ اپ کے لیے: <span className="common-Link">+92 308 9394272</span>
                      </p>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default SubscriptionPlans;